import { TransportProvider } from '@connectrpc/connect-query'
import { queryClient, transport } from '@customer/request/client'
import { ColorSimulationPage } from '@customer/template/ColorSimulation/ColorSimulationPage'
import { ReviewPage } from '@customer/template/ReviewForm/ReviewPage'
import { QueryClientProvider } from '@tanstack/react-query'

/** /review/:slug の slug と ?deal=<id> をパスから解決する */
const parseReviewRoute = (): { slug: string; dealId?: bigint } | null => {
  if (typeof window === 'undefined') return null
  const { pathname, search } = window.location
  if (!pathname.startsWith('/review/')) return null
  const slug = decodeURIComponent(pathname.slice('/review/'.length).split('/')[0] ?? '')
  if (!slug) return null
  const dealParam = new URLSearchParams(search).get('deal')
  const dealId = dealParam && /^\d+$/.test(dealParam) ? BigInt(dealParam) : undefined
  return { slug, dealId }
}

export const App = () => {
  const reviewRoute = parseReviewRoute()

  return (
    <TransportProvider transport={transport}>
      <QueryClientProvider client={queryClient}>
        {reviewRoute ? (
          <ReviewPage slug={reviewRoute.slug} dealId={reviewRoute.dealId} />
        ) : (
          <ColorSimulationPage />
        )}
      </QueryClientProvider>
    </TransportProvider>
  )
}
